<template>
  <div v-title data-title="关键流程">
    <div class="sms-content-main">
      <div class="core-risk-box" ref="keyProcessBox">
        <div class="sms-cell-box" v-for="item in cardData" :key="item.code"
             :class="{'card-active':system.code===item.code}"
             @click="onCardClick(item)">
          <KeyProcessCard :system="item"></KeyProcessCard>
        </div>
      </div>
      <div class="core-risk-month">
        <div class="sms-module-header">
          {{ system.name }}-月度管控状态
          <div class="el-date-picker-wrapper year-wrapper">
            <el-date-picker v-model="year" type="year" format="yyyy年" value-format="yyyy" :clearable="false"
                            :editable="false" placeholder="选择年">
            </el-date-picker>
          </div>
        </div>
        <CoreRiskMonth v-if="system.code" :system="system.code" :year="Number(year)"></CoreRiskMonth>
      </div>

      <div class="core-risk-danger">
        <div class="sms-module-header">
          {{ system.name }}-工作流程检查单库
        </div>
        <div class="risk-table-box">
          <KeyProcessProblem v-if="system.code" :system="system.code" :subProcess.sync="subProcess"></KeyProcessProblem>
        </div>
      </div>
      <div class="core-risk-kpi">
        <div class="sms-module-header">
          <!-- 存在该样式时kpi-prefix-box-dynamic，鼠标悬浮出现移除按钮  -->
          <div class="kpi-prefix-box" :class="{ 'kpi-prefix-box-dynamic': kpi.prefix.remove }">
            <p>{{ kpi.prefix.name }}</p>
            <i class="el-icon-error" @click="removeKpiPrefix"></i>
          </div>
          -关联KPI指标
        </div>
        <div class="risk-table-box">
          <CoreRiskKpi v-if="system.code && kpi.enable"
                       :system="system.code"
                       :subProcessId="subProcess.id"
                       :year="Number(year)"
                       :kpiCode.sync="kpi.code"></CoreRiskKpi>
        </div>
      </div>
    </div>
    <!-- 当KPI存在时，才加载 -->
    <div class="sms-content-main" v-if="kpi.code">
      <div id="kpiChart" class="core-risk-warn">
        <KpiChart :kpiCode="kpi.code" :year="Number(year)"></KpiChart>
      </div>
    </div>
  </div>
</template>

<script>
import CoreRiskMonth from "./risk/CoreRiskMonth";
import CoreRiskDanger from "./risk/CoreRiskDanger";
import CoreRiskKpi from "./risk/CoreRiskKpi";
import KpiChart from "./risk/KpiChart";
import CoreRiskCard from "./risk/CoreRiskCard";
import {getRequest} from "../../utils/request";
import KeyProcessCard from "./process/KeyProcessCard";
import KeyProcessProblem from "./process/KeyProcessProblem";

export default {
  props: {
    company: String,
  },
  data() {
    return {
      //卡片数据
      cardData: [],
      //系统
      system: {
        code: null,
        name: null,
      },
      subProcess: {
        id: null,
        name: null,
      },
      //KPI
      kpi: {
        //与system.code共同控制关联kpi组件
        enable: true,
        name: null,
        code: null,
        prefix: {
          //前缀（默认为核心风险名称）
          name: null,
          //前缀可否被移除
          remove: false,
        },
      },
      //年份，默认今年
      year: String(new Date().getFullYear()),
    }
  },
  mounted() {
    this.buildCard();
  },
  methods: {
    buildCard() {
      this.system = {code: null, name: null};
      this.cardData = [];
      getRequest("process/key/cards", {}, this.$refs.keyProcessBox).then(res => {
        this.cardData = res.data;

        //已指定某个核心风险时，使用指定的；未选择任何核心风险时，默认激活第1个核心风险
        let system = this.$route.query.code ? this.cardData.find(item => item.code === this.$route.query.code) : this.cardData[0];
        //code设置后，月度管控、危险源、kpi开始加载
        this.system = Object.assign({}, this.system, system)
        //注：这里需要先执行，后续如果存在danger，可能会覆盖
        this.setKeyProcessKpiPrefix();
        //设置默认值
        if (this.$route.query.year)
          this.year = this.$route.query.year;
        if (this.$route.query.kpiCode)
          //先确保关联kpi加载完成
          this.$nextTick(() => {
            this.kpi.code = this.$route.query.kpiCode;
            //滚动到锚点（更新kpi.code触发v-if，确保dom渲染后再hash）
            this.$nextTick(() => location.hash = "kpiChart")
          })
      })
    },
    /**
     * 核心风险卡片切换
     * 1.禁用kpi
     * 2.重置典型事件和危险源（这样kpi不会因为它俩触发watch）
     * 3.更新核心风险
     * 4.启用kpi
     */
    onCardClick(system) {
      this.kpi.enable = false;
      this.$nextTick(() => {
        this.resetWithoutWatch();
        this.system = Object.assign({}, this.system, system)
        this.kpi.enable = true;
        this.setKeyProcessKpiPrefix();
      })
    },
    /**
     * 移除kpi前缀
     * 1.禁用kpi
     * 2.重置典型事件和危险源（这样kpi不会因为它俩触发watch）
     * 3.启用kpi
     */
    removeKpiPrefix() {
      this.kpi.enable = false;
      this.$nextTick(() => {
        this.resetWithoutWatch();
        this.kpi.enable = true;
        this.setKeyProcessKpiPrefix();
      })
    },
    /**
     * 安全的重置子流程
     * 这里不触发watch
     */
    resetWithoutWatch() {
      this.subProcess.id = null;
      this.subProcess.name = null;
    },
    setKeyProcessKpiPrefix() {
      this.kpi.prefix.name = this.system.name;
      this.kpi.prefix.remove = false;
    },
  },
  watch: {
    subProcess() {
      this.kpi.prefix.name = this.subProcess.name;
      this.kpi.prefix.remove = true;
    },
    company() {
      this.buildCard();
    }
  },
  components: {
    KeyProcessProblem,
    KeyProcessCard,
    CoreRiskMonth,
    CoreRiskDanger,
    CoreRiskKpi,
    KpiChart,
    CoreRiskCard,
  }
}
</script>

<style scoped lang="less">
.sms-content-main {
  background-color: #fff;
  border-radius: 10px;
  padding: 13px 18px 18px 18px;

  //模块标题统一样式
  /deep/ .sms-module-header {
    display: flex;
    align-items: center;
    height: 40px;
    font-weight: bold;
  }

  //控制表格子组件的表头样式
  /deep/ .risk-table-header {
    background-color: #f0f1f7;
    border: 0 !important;
    padding: 5px 0;
    color: #000;
    font-size: 13px;
  }
}

.sms-content-main:not(:first-child) {
  margin-top: 20px;
}

.core-risk-box {
  display: flex;
  flex-wrap: wrap;
  height: 210px;
}

.sms-cell-box {
  height: 100px;
  width: 12%;
  border-radius: 10px;
  box-shadow: 0 0 10px #f0f1f7;
  display: flex;
  align-items: center;
  justify-content: center;
}

/*计算margin，每行9个块，每个10.5%宽，每行8个margin*/
.sms-cell-box:not(:nth-child(8n)) {
  margin-right: ((100%-(12%*8))/7);
}

.sms-cell-box:hover {
  cursor: pointer;
  transition: box-shadow 618ms;
  box-shadow: 0 0 17px #000;
}

.card-active {
  color: #fff;
  background-color: #34405c;
}

/*从第8个开始，都有上边距*/
.sms-cell-box:nth-child(n+9) {
  margin-top: 10px;
}

.risk-table-box {
  background-color: #f0f1f7;
  padding: 0 14px 35px 18px;

  /deep/ .el-table__body-wrapper::-webkit-scrollbar {
    width: 3px;
  }

  /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #c8c8c8;
  }

  //表体单元格
  /deep/ .cell-class {
    font-size: 12px;
    padding: 5px 0;
  }
}

.core-risk-warn {
}

.core-risk-month {
  margin-top: 30px;

  .year-wrapper {
    margin-left: 20px;

    .el-date-editor {
      width: 185px;
    }
  }
}

//核心风险 - 危险源
.core-risk-danger {
  margin-top: 5px;
}

.core-risk-kpi {
  margin-top: 15px;

  .sms-module-header {

    .kpi-prefix-box {
      display: flex;
      align-items: center;
      height: 35px;
      border-radius: 5px;
      padding-left: 7px;

      .el-icon-error {
        display: none;
        padding: 3px;
        cursor: pointer;
      }
    }

    .kpi-prefix-box-dynamic {
      &:hover {
        background-color: #35425d;
        color: #fff;
        padding-right: 7px;
      }

      &:hover .el-icon-error {
        display: block;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/achievement/KeyProcess.vue